/**
 * Speed-up helpers for IPFS-hosted media.
 *
 * All media goes through the dedicated Pinata gateway (nomelupin).
 *
 * NOTE: keep the output in "path form" (https://gw/ipfs/CID/...) so that
 * downstream components (IpfsImage) can extract the CID and cascade through
 * fallback gateways when a request fails.
 */

const PINATA_GATEWAY_RE = /^https?:\/\/[^/]*pinata[^/]*\/ipfs\/(?:ipfs\/)*([a-zA-Z0-9]+)(\/.*)?$/i;
const IPFS_PATH_RE = /^https?:\/\/[^/]+\/ipfs\/(?:ipfs\/)*([a-zA-Z0-9]+)(\/.*)?$/i;
// Subdomain form: https://<cid>.ipfs.<host>/<rest>
const IPFS_SUBDOMAIN_RE = /^https?:\/\/([a-z0-9]+)\.ipfs\.[^/]+(\/.*)?$/i;

// Single dedicated Pinata gateway used for ALL media.
export const IPFS_GATEWAY = "https://nomelupin.mypinata.cloud";
const PRIMARY_GATEWAY = IPFS_GATEWAY;

export function fastIpfsUrl(url) {
    if (!url) return url;
    const m = url.match(PINATA_GATEWAY_RE) || url.match(IPFS_PATH_RE) || url.match(IPFS_SUBDOMAIN_RE);
    if (!m) return url;
    const [, cid, rest = ""] = m;
    // Always route through the dedicated Pinata gateway in path form so
    // <IpfsImage> can cascade to fallbacks if needed.
    return `${PRIMARY_GATEWAY}/ipfs/${cid}${rest || ""}`;
}

/** Preload an array of image URLs so they are cached when rendered. */
export function preloadImages(urls = []) {
    for (const u of urls) {
        if (!u) continue;
        const img = new Image();
        img.decoding = "async";
        img.src = fastIpfsUrl(u);
    }
}
